import api from 'Application/api/api';

const getTasksProgress = (cancelToken = null) =>
    api.get('/companies/current/tasks-progress', { cancelToken });

export default getTasksProgress;
